import { CompanyDto } from './company-dto.model';


export class EducationDto implements IEducationDto {
    id!: number;
    educationName!: string | undefined;
    companyId!: number;
    company!: CompanyDto;
    isActive!: boolean;

    constructor(data?: IEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.educationName = _data["educationName"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["educationName"] = this.educationName;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IEducationDto {
    id: number;
    educationName: string | undefined;
    companyId: number;
    company: CompanyDto;
    isActive: boolean;
}

